module.exports = __webpack_public_path__ + "img/vitamin-2.53a91d3f.png";